module.exports = {
          srcSet: __webpack_public_path__ + "684e0cbedebd837261f0a6093c9f50ec-700.png"+" 700w",
          images:[ {path: __webpack_public_path__ + "684e0cbedebd837261f0a6093c9f50ec-700.png",width: 700,height: 394}],
          src: __webpack_public_path__ + "684e0cbedebd837261f0a6093c9f50ec-700.png",
          toString:function(){return __webpack_public_path__ + "684e0cbedebd837261f0a6093c9f50ec-700.png"},
          
          width: 700,
          height: 394
        }